export let routes = [
  {
    path: '/x3-side-sf-type',
    name: 'x3-side-sf-type',
    component: () => import('@x3/js/side/sf-type/sf-type.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsSfType(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-sf-type',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
